<template>
  <div class="card-form">
    <page-main
      ref="main"
      :loading="loading"
      :table-data="table"
      :tablePage="page"
      :tree-data="treeData"
      @leftClick="leftClick"
      @submit="reload"
      ><page-header
        @reset="reset"
        @submit="handleSubmit"
        @printTag="printTag"
        @turnover="turnover"
        slot="header"
        ref="header"/>
      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="right"
        slot="pager"
        @change="handlePaginationChange"
    /></page-main>
  </div>
</template>
<script>
export default {
  components: {
    PageHeader: () => import('./components/header'),
    PageMain: () => import('./components/main'),
  },
  data() {
    return {
      treeData: [],
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 20,
        pageTotal: 0,
      },
    }
  },
  methods: {
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 20,
        pageTotal: 0,
      }
    },
    reload() {
      this.$refs.header.query()
    },
    leftClick(form) {
      this.$refs.header.assign(form)
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    //加载数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .fabricStockListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    printTag() {
      this.$refs.main.printTag()
    },
    //业务人员调整
    turnover() {
      this.$refs.main.turnover()
    },
  },
}
</script>
